module.exports = __webpack_public_path__ + "static/img/8.10b775c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content-management/8.jpeg
// module id = xLTo
// module chunks = 3